import type { AxiosResponse } from 'axios';
import type { CreditLog } from '@app-types/models/finance';
import api from './api';

interface CreditLogsResponse {
  creditLogs: CreditLog[];
  [key: string]: unknown;
}

export const getCreditLogs = async (): Promise<CreditLogsResponse> => {
  try {
    const response: AxiosResponse<CreditLogsResponse> = await api.get('/business/credit-logs');
    return response.data;
  } catch (error: unknown) {
    const axiosError = error as { response?: { data?: unknown }; message?: string };
    console.error('Error fetching payout logs:', axiosError.response?.data || axiosError.message);
    throw error;
  }
}
